<div class="mainContainer d-flex align-items-center Wrap">
  <div class="title">
    <h2 class="headingBL">
      Our <span><br />Maestros</span>
    </h2>
  </div>
  <button (click)="scrollRight()" >
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
  <div class="d-flex gap-4 my-5 cardWrap" #scrollContent>
    <div
      class="advisors"
      (click)="openDialog(maestro.id)"
      *ngFor="let maestro of maestro; let i = index"
    >
      <div class="advisorsCard position-relative">
        <img loading="lazy" class="advisorsImage" [src]="maestro.thumbnail" />
        <div class="details">
          <div class="name" style="font-weight: 900">
            {{ maestro.artist_name }}
            <br />...
          </div>
        </div>
      </div>
      <div class="explore">
        <div class="vtext exdetails">{{ transform(maestro.about_us) }}</div>
        <div class="explore-more">Explore More &gt;&gt;</div>
      </div>
    </div>
  </div>
  <button (click)="scrollLeft()">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
</div>
